import { createSelector } from '@ngrx/store';
import { selectAllOrganizations, getSelectedOrganizationId, getIsOrganizationsFetched } from '../organizations/organizations.selector';
import { IWorkspaceInstance } from '../workspaces/workspaces.reducer';
import { IOrganizationInstance } from '../organizations/organizations.reducer';
import { getSelectedWorkspaceId, selectAllAvailableWorkspaces, getIsWorkspacesFetched } from '../workspaces/workspaces.selector';

export const getAllAvailableOrganizations = createSelector(
    selectAllOrganizations, selectAllAvailableWorkspaces,
    (organizations: IOrganizationInstance[], workspaces: IWorkspaceInstance[]) => {
        if(organizations) {
            const activeOrgs = organizations.filter((organization) => {
                return !organization.suspended;
            })
            return activeOrgs.filter((organization) => {
                return workspaces.some((workspace) => workspace.orgId == organization.globalId);
            })
        } else {
            return [];
        }
        
    }
  )


export const getCurrentOrgWorkspaces = createSelector(
    selectAllAvailableWorkspaces, getSelectedOrganizationId, selectAllOrganizations,
    (workspaces, orgId, organizations) => {
        if(organizations && organizations.length) {
            if(orgId) {
                return Object.values(workspaces).filter((workspace) => {
                    return workspace.orgId == orgId;
                });
            } else {
                return Object.values(workspaces).filter((workspace) => {
                    const isOrgExist = organizations.find((organization) => organization.globalId == workspace.orgId)
                    return !isOrgExist;
                })
            }
        } else {
            return workspaces;
        }
    }
)

export const getSelectedWorkspace = createSelector(
    getCurrentOrgWorkspaces, getSelectedWorkspaceId,
    (workspaces: IWorkspaceInstance[], selectedWorkspaceId: string) => {
      if(selectedWorkspaceId) {
        return workspaces.find((workspace) => workspace.globalId == selectedWorkspaceId);
      } else {
        const defaultWorkspace = workspaces.find((workspace) => workspace.isDefault);
        if(defaultWorkspace) {
          return defaultWorkspace;
        } else {
          return workspaces[0];
        }
      }
      
    }
  )

export const getIsSelectReady = createSelector(
    getIsWorkspacesFetched, getIsOrganizationsFetched,
    (isWorkspacesFetched, isOrganizationsFetched) => {
        return isWorkspacesFetched && isOrganizationsFetched;
    }
)

